import { Control } from 'react-hook-form'
import {
	FormControl,
	FormDescription,
	FormField,
	FormItem,
	FormLabel,
	FormMessage,
} from '@/common/ui/form'
import UploadImage from '@/common/components/UploadImage'
import useMutationGetBrokeNotificationUploadUrl from '@/core/api/hooks/useMutationGetBrokeNotificationUploadUrl'
import type { NotificationItemFormData } from '../types'

interface ImageUploadFieldProps {
	control: Control<NotificationItemFormData>
	onImageUploaded: (fileUrl: string) => void
}

export default function ImageUploadField({
	control,
	onImageUploaded,
}: ImageUploadFieldProps) {
	const { mutateAsync: getBrokeNotificationFileUrl } =
		useMutationGetBrokeNotificationUploadUrl()

	return (
		<FormField
			control={control}
			name="imageUrl"
			render={({ field }) => (
				<FormItem>
					<FormLabel>
						รูปภาพ <span className="text-muted-foreground">(ไม่บังคับ)</span>
					</FormLabel>
					<FormControl>
						<UploadImage
							onImageUploaded={onImageUploaded}
							defaultValue={field.value || ''}
							getFileUrl={({ payload }) =>
								getBrokeNotificationFileUrl({
									fileExtension: payload.fileExtension,
								})
							}
							aspectRatio="16/9"
							previewHeight={120}
						/>
					</FormControl>
					<FormDescription>
						รูปภาพที่จะแสดงในรายการ (แนะนำขนาด 1200x675 พิกเซล)
					</FormDescription>
					<FormMessage />
				</FormItem>
			)}
		/>
	)
}
